import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchShifts } from '../actions/shifts';
import { fetchPromoter } from '../actions/promoters'
import { fetchObjective } from '../actions/objectives'
import { fetchArqueos } from '../actions/arqueos'

import ErrorMessage from '../components/ErrorMessage'
import Box from '../components/Box'
import '../styles/MachinesAdminView.css'

class PromoterShiftView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedDay: null,
    };

  }

  componentDidMount() {
    const { fullname } = this.props
    const startDate = new Date(new Date().getFullYear() - 1, 0, 1).toISOString().substring(0, 10);
    const endDate = new Date().toISOString().substring(0, 10);

    this.props.fetchPromoter(this.props.match.params.Name).then((promoterAction) => {
      const promoterFullname = (promoterAction && promoterAction.response && promoterAction.response.fullname) || ''
      if (!promoterFullname) return
      this.props.fetchShifts(promoterFullname, '', startDate, endDate)
        .then((answer) => {

          let shiftCustomer = ''
          const today = new Date();
          const currentYear = today.getFullYear().toString();

          if (answer.response.length > 0) {
            shiftCustomer = answer.response[0].machine.Customer;
          }

          this.props.fetchObjective(shiftCustomer, currentYear)
          .then((answer) => {
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth();

            // Start date is the first day of the current month
            const startDate = new Date(currentYear, currentMonth, 1);
            const formattedStartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`;

            // End date is tomorrow
            const endDate = new Date(today);
            endDate.setDate(today.getDate() + 1);
            const formattedEndDate = `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;

            this.props.fetchArqueos('', shiftCustomer, formattedStartDate, formattedEndDate, '');
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
    })
  }

  calculateTotalKPILay() {
    const { arqueos } = this.props

    if (!arqueos) {
      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    let kpiLay = 0;
    let totalPack = 0;
    let totalLay = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiLay = (totalLay / totalPack) * 100

    return kpiLay
  }

  calculateTotalKPIGo() {
    const { arqueos } = this.props

    if (!arqueos) {
      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    let kpiGo = 0;
    let totalPack = 0;
    let totalGo = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiGo = (totalGo / totalPack) * 100

    return kpiGo
  }

  calculateTotalCrossSale() {
    const { arqueos } = this.props

    if (!arqueos) {
      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    let kpiCross = 0;
    let totalPack = 0;
    let totalLay = 0;
    let totalGo = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiCross = ((totalGo + totalLay) / totalPack) * 100

    return kpiCross
  }

  progressBar(actual, ob) {
    const { arqueos } = this.props

    if (!arqueos) {
      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    let percentage = Math.min((actual / ob) * 100, 100);

    if (ob === 0) {
      percentage = 0;
    }

    let color = "bg-warning"

    if (percentage < 50) {
      color = "bg-danger"
    } else if (percentage === 100) {
      color = "bg-success"
    }

    return (
      <div className="progress-container-promoter">
        <div className={`progress-bar-promoter ${color}`} style={{ width: `${percentage}%` }}></div>
        <div className="progress-percentage-promoter">{percentage.toFixed(2)}%</div>
      </div>
    );
  }

  calculateTotalMonthObjective() {
    const { currentMonth } = this.getCurrentMonthInfo();
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    let totalObjectives = 0;

    if (this.props.objective && currentMonth >= 1 && currentMonth <= 12) {
      weeks.forEach(week => {
        if (this.props.objective[months[currentMonth - 1]] && this.props.objective[months[currentMonth - 1]][week]) {
          totalObjectives += this.props.objective[months[currentMonth - 1]][week];
        }
      });
    } else {
      console.error("Error: Missing or invalid objective data or current month.");
    }

    return totalObjectives;
  }

  calculatePriceWithoutTax(priceWithTax, taxRate) {
    // Convert tax rate from percentage to decimal
    const taxMultiplier = 1 + taxRate / 100;

    // Calculate price without tax and round to two decimal places
    const priceWithoutTax = (priceWithTax / taxMultiplier).toFixed(2);

    // Convert the string back to a number
    return parseFloat(priceWithoutTax);
  }

  calculateTotalMonthReal() {

    let totalReal = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalReal += this.calculatePriceWithoutTax(arqueo.SalesTotal, arqueo.Tax)
      }
      )
    }

    return totalReal
  }

  renderStartHour(name, day) {
    const { shifts, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!shifts || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let initHour = "None";

    const filteredShifts = shifts.filter(shift => {
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

      return shift.workerName === name && shiftDay === day;
    });

    filteredShifts.forEach((shift) => {
      if (shift.workerName === name) {
        const shiftDate = new Date(shift.date);
        initHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
      }
    });

    return initHour;
  }

  renderFinishHour(name, day) {
    const { shifts, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!shifts || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let finishHour = "None";
    let done = false;
    let counter = 0;

    const filteredShifts = shifts.filter(shift => {
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

      return shift.workerName === name && (day ? shiftDay === day : true);
    });

    filteredShifts.forEach((shift) => {
      if (!done) {
        const shiftDate = new Date(shift.date);
        finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
        done = true;
      }
    });

    filteredShifts.forEach((shift) => {
      counter++;
    });

    if (counter === 1) {
      finishHour = "None";
    }

    return finishHour;
  }

  renderTotalHour(name, rest, day) {
    const { shifts, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!shifts || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let initHour = "None";
    let finishHour = "None";
    let done = false;
    let counter = 0;

    const filteredShifts = shifts.filter(shift => {
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

      return shift.workerName === name && (day ? shiftDay === day : true);
    });

    filteredShifts.forEach((shift) => {
      const shiftDate = new Date(shift.date);
      initHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
    });

    filteredShifts.forEach((shift) => {
      if (!done) {
        const shiftDate = new Date(shift.date);
        finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });

        done = true;
      }
    });

    filteredShifts.forEach((shift) => {
      counter++;
    });

    if (counter === 1) {
      const shiftDate = new Date();
      finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
    }

    let totalHours = `0h00m`;

    if (initHour !== "None" && finishHour !== "None") {
      // Parse the time strings into Date objects
      const initTime = new Date(`2000-01-01 ${initHour}`);
      const finishTime = new Date(`2000-01-01 ${finishHour}`);

      // Calculate the time difference in milliseconds
      let timeDiff = finishTime - initTime;

      // Subtract rest time if rest is provided
      if (rest && typeof rest === 'number') {
        timeDiff -= rest * 60 * 1000; // Convert rest time to milliseconds
      }

      // Convert the time difference to hours and minutes
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const totalMinutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

      // Ensure minutes are always represented by at least two digits
      const minutes = totalMinutes.toString().padStart(2, '0');

      totalHours = `${hours}h${minutes}m`;
    }

    return totalHours;
  }

  getCurrentMonthInfo() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-based index
    const currentYear = currentDate.getFullYear();

    // Get the first day of the next month to determine the last day of the current month
    const firstDayOfNextMonth = new Date(currentYear, currentMonth + 1, 1);
    const lastDayOfCurrentMonth = new Date(firstDayOfNextMonth - 1);

    const numberOfDaysInMonth = lastDayOfCurrentMonth.getDate();

    // Determine the first day of the current week
    const firstDayOfCurrentWeek = new Date(currentDate);
    firstDayOfCurrentWeek.setDate(currentDate.getDate() - currentDate.getDay() + (currentDate.getDay() === 0 ? -6 : 1));

    return {
      currentMonth: currentMonth + 1, // Adding 1 to convert to 1-based index
      currentYear: currentYear,
      numberOfDaysInMonth: numberOfDaysInMonth,
      firstDayOfCurrentWeek: firstDayOfCurrentWeek.getDate() // Returns the day of the month (1-31)
    };
  }

  renderTotalMonthHour(name, rest) {
    const { shifts, error, loading } = this.props;
    const { currentMonth, currentYear, numberOfDaysInMonth } = this.getCurrentMonthInfo();

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!shifts || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let totalMonthHours = 0;
    let totalHours = 0;

    for (let day = 1; day <= numberOfDaysInMonth; day++) {

      let initHour = "None";
      let finishHour = "None";
      let done = false;
      let counter = 0;

      const filteredShifts = shifts.filter(shift => {
        const shiftDate = new Date(shift.date);
        const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

        return shift.workerName === name && (day ? shiftDay === `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}` : true);
      });

      filteredShifts.forEach((shift) => {
        const shiftDate = new Date(shift.date);
        initHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
      });

      filteredShifts.forEach((shift) => {
        if (!done) {
          const shiftDate = new Date(shift.date);
          finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });

          done = true;
        }
      });

      filteredShifts.forEach((shift) => {
        counter++;
      });

      if (counter === 1) {
        finishHour = "None";
      }

      let timeDiff = 0;

      if (initHour !== "None" && finishHour !== "None") {
        // Parse the time strings into Date objects
        const initTime = new Date(`2000-01-01 ${initHour}`);
        const finishTime = new Date(`2000-01-01 ${finishHour}`);

        // Calculate the time difference in milliseconds
        timeDiff = finishTime - initTime;

        // Subtract rest time if rest is provided
        if (rest && typeof rest === 'number') {
          timeDiff -= rest * 60 * 1000; // Convert rest time to milliseconds
        }

      }

      totalHours += timeDiff
    }

    // Convert the time difference to hours and minutes
    const hours = Math.floor(totalHours / (1000 * 60 * 60));
    const totalMinutes = Math.floor((totalHours % (1000 * 60 * 60)) / (1000 * 60));

    // Ensure minutes are always represented by at least two digits
    const minutes = totalMinutes.toString().padStart(2, '0');

    totalMonthHours = `${hours}h${minutes}m`;

    return totalMonthHours;
  }

  renderTotalWeekHours(name, rest) {
    const { shifts, error, loading } = this.props;
    const { currentMonth, currentYear, numberOfDaysInMonth, firstDayOfCurrentWeek } = this.getCurrentMonthInfo();

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!shifts || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let totalMonthHours = 0;
    let totalHours = 0;

    for (let day = firstDayOfCurrentWeek; day <= numberOfDaysInMonth; day++) {

      let initHour = "None";
      let finishHour = "None";
      let done = false;
      let counter = 0;

      const filteredShifts = shifts.filter(shift => {
        const shiftDate = new Date(shift.date);
        const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

        return shift.workerName === name && (day ? shiftDay === `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}` : true);
      });

      filteredShifts.forEach((shift) => {
        const shiftDate = new Date(shift.date);
        initHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
      });

      filteredShifts.forEach((shift) => {
        if (!done) {
          const shiftDate = new Date(shift.date);
          finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });

          done = true;
        }
      });

      filteredShifts.forEach((shift) => {
        counter++;
      });

      if (counter === 1) {
        finishHour = "None";
      }

      let timeDiff = 0;

      if (initHour !== "None" && finishHour !== "None") {
        // Parse the time strings into Date objects
        const initTime = new Date(`2000-01-01 ${initHour}`);
        const finishTime = new Date(`2000-01-01 ${finishHour}`);

        // Calculate the time difference in milliseconds
        timeDiff = finishTime - initTime;

        // Subtract rest time if rest is provided
        if (rest && typeof rest === 'number') {
          timeDiff -= rest * 60 * 1000; // Convert rest time to milliseconds
        }

      }

      totalHours += timeDiff
    }

    // Convert the time difference to hours and minutes
    const hours = Math.floor(totalHours / (1000 * 60 * 60));
    const totalMinutes = Math.floor((totalHours % (1000 * 60 * 60)) / (1000 * 60));

    // Ensure minutes are always represented by at least two digits
    const minutes = totalMinutes.toString().padStart(2, '0');

    totalMonthHours = `${hours}h${minutes}m`;

    return totalMonthHours;
  }

  handleDayClick(year, month, day) {
    const clickedDay = new Date(year, month, day);

    if (
      this.state.selectedDay &&
      clickedDay.getTime() === this.state.selectedDay.getTime()
    ) {
      this.setState({ selectedDay: null }, () => {

      });
    } else {
      // If the clicked day is different, update selectedDay with the new value
      this.setState({ selectedDay: clickedDay }, () => {

      });
    }
  }

  renderRegisterDaysShifts() {
    const { shifts, error, promoter } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!shifts) {
      return (
        <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      );
    }

    const shiftsByYearMonth = {};
    shifts.forEach(shift => {
      const d = new Date(shift.date);
      const year = d.getUTCFullYear();
      const month = d.getUTCMonth();
      const day = d.getUTCDate();
      shiftsByYearMonth[year] = shiftsByYearMonth[year] || {};
      shiftsByYearMonth[year][month] = shiftsByYearMonth[year][month] || [];
      if (!shiftsByYearMonth[year][month].includes(day)) {
        shiftsByYearMonth[year][month].push(day);
      }
    });

    const today = new Date();
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    const years = Object.keys(shiftsByYearMonth).sort((a, b) => parseInt(b) - parseInt(a));
    const MONTH_NAMES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    const DOW = ['Lu','Ma','Mi','Ju','Vi','Sa','Do'];

    const dayStyle = (base) => ({
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      width: 32, height: 32, borderRadius: 8, fontSize: '0.78rem',
      fontWeight: 600, cursor: 'pointer', transition: 'transform 0.12s',
      position: 'relative', userSelect: 'none',
      ...base
    });

    const STATUS = {
      complete: { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' },
      mid:      { background: '#fef9c3', color: '#854d0e', border: '1px solid #fde047' },
      none:     { background: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' },
      weekend:  { background: '#f8fafc', color: '#94a3b8', border: '1px solid #e2e8f0' },
      today:    { background: '#0a4080', color: '#fff',    border: '2px solid #0369a1' },
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        {years.map(year => (
          <div key={year}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
              <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.08em' }}>{year}</span>
              <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
              {Array.from({ length: 12 }, (_, month) => {
                const monthDays = new Date(year, month + 1, 0).getDate();
                const shiftDays = (shiftsByYearMonth[year] && shiftsByYearMonth[year][month]) ? shiftsByYearMonth[year][month] : [];
                const firstDow = new Date(year, month, 1).getDay();
                const offset = firstDow === 0 ? 6 : firstDow - 1;
                const mm = String(month + 1).padStart(2, '0');

                return (
                  <div key={month} style={{
                    background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0',
                    padding: '12px 14px', minWidth: 224, flex: '0 0 auto',
                    boxShadow: '0 1px 6px rgba(10,64,128,0.06)'
                  }}>
                    <div style={{ fontSize: '0.8rem', fontWeight: 700, color: '#1e293b', marginBottom: 8, textTransform: 'capitalize' }}>
                      {MONTH_NAMES[month]}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 32px)', gap: 2 }}>
                      {DOW.map(d => (
                        <div key={d} style={{ width: 32, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700, color: '#94a3b8' }}>{d}</div>
                      ))}
                      {Array.from({ length: offset }, (_, i) => <div key={`sp-${i}`} />)}
                      {Array.from({ length: monthDays }, (_, i) => {
                        const dn = i + 1;
                        const dateStr = `${year}-${mm}-${String(dn).padStart(2, '0')}`;
                        const isToday = dateStr === todayStr;
                        const dow = new Date(year, month, dn).getDay();
                        const isWeekend = dow === 0 || dow === 6;
                        const start = this.renderStartHour(promoter.fullname, dateStr);
                        const end = this.renderFinishHour(promoter.fullname, dateStr);
                        const hasStart = start !== 'None';
                        const hasEnd = end !== 'None';
                        let status = isWeekend ? 'weekend' : 'none';
                        if (shiftDays.includes(dn)) status = 'complete';
                        if (hasStart && !hasEnd) status = 'mid';
                        if (isToday) status = 'today';
                        const currentDay = new Date(year, month, dn);
                        const isSelected = this.state.selectedDay && this.state.selectedDay.toDateString() === currentDay.toDateString();

                        return (
                          <div
                            key={dn}
                            style={dayStyle({ ...STATUS[status], ...(isSelected ? { zIndex: 100, position: 'relative' } : {}) })}
                            onClick={() => this.handleDayClick(year, month, dn)}
                            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.2)'; }}
                            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
                          >
                            {dn}
                            {isSelected && (
                              <div style={{
                                position: 'absolute', top: 38, left: '50%', transform: 'translateX(-50%)',
                                background: '#1e293b', color: '#fff', borderRadius: 10, padding: '10px 14px',
                                zIndex: 20, minWidth: 160, boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                                fontSize: '0.75rem', lineHeight: 1.7, whiteSpace: 'nowrap'
                              }}>
                                <div style={{ fontWeight: 700, marginBottom: 4 }}>{currentDay.toLocaleDateString('es-ES')}</div>
                                <div><i className="fas fa-sign-in-alt" style={{ marginRight: 4, color: '#38bdf8' }}></i>{start}</div>
                                <div><i className="fas fa-sign-out-alt" style={{ marginRight: 4, color: '#f472b6' }}></i>{end}</div>
                                <div><i className="fas fa-clock" style={{ marginRight: 4, color: '#a78bfa' }}></i>{this.renderTotalHour(promoter.fullname, promoter.rest, dateStr)}</div>
                                <div
                                  onClick={e => { e.stopPropagation(); this.setState({ selectedDay: null }); }}
                                  style={{ marginTop: 6, textAlign: 'center', cursor: 'pointer', color: '#94a3b8', fontSize: '0.7rem' }}
                                >
                                  <i className="fas fa-times"></i> Cerrar
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  }

  getUserRest(rest) {

    switch (rest) {
      case 30: return "30 min";
      case 60: return "1 hora";
      default: return "No";
    }
  }

  getUserType(type) {
    switch (type) {
      case "GOD": return "Administrador";
      case "MASTER": return "Editor";
      case "HHRR": return "Recursos Humanos";
      case "LIMITED": return "Trabajador";
      default: return "Sin rol";
    }
  }

  renderShiftHeatmap() {
    const { shifts, promoter } = this.props;
    if (!shifts || !promoter) return null;

    const today = new Date().toISOString().substring(0, 10);
    const calendarDays = [];
    for (let i = 29; i >= 0; i--) {
      const d = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
      calendarDays.push(d.toISOString().substring(0, 10));
    }

    const workingDays = {};
    shifts.forEach(shift => {
      const shiftDate = new Date(shift.date);
      const day = shiftDate.toISOString().substring(0, 10);
      if (!workingDays[day]) workingDays[day] = { shifts: [] };
      workingDays[day].shifts.push(shiftDate);
    });

    Object.keys(workingDays).forEach(day => {
      const sorted = workingDays[day].shifts.sort((a, b) => a - b);
      workingDays[day].startTime = sorted[0].toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
      workingDays[day].endTime = sorted[sorted.length - 1].toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
      const hoursDiff = (sorted[sorted.length - 1] - sorted[0]) / (1000 * 60 * 60);
      workingDays[day].hoursWorked = hoursDiff.toFixed(1);
      workingDays[day].complete = sorted.length > 1;
    });

    return (
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: 8, fontWeight: 600 }}>
          <i className="fas fa-calendar-alt"></i> Calendario de trabajo (ultimos 30 dias)
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(22px, 1fr))',
          gap: 4,
          padding: 10,
          backgroundColor: 'white',
          borderRadius: 8,
          border: '1px solid #e2e8f0'
        }}>
          {calendarDays.map(day => {
            const worked = workingDays[day];
            const isToday = day === today;
            const date = new Date(day + 'T12:00:00');
            const dow = date.getDay();
            const isWeekend = dow === 0 || dow === 6;
            let bg = isWeekend ? '#f1f5f9' : 'white';
            let border = '1px solid #e2e8f0';
            if (worked) {
              bg = worked.complete ? (isToday ? '#22c55e' : '#0ea5e9') : '#f59e0b';
              border = worked.complete ? (isToday ? '2px solid #16a34a' : '1px solid #0284c7') : '1px solid #d97706';
            }
            return (
              <div key={day}
                title={worked
                  ? (date.toLocaleDateString('es-ES') + ' - ' + worked.startTime + ' -> ' + worked.endTime + ' (' + worked.hoursWorked + 'h)')
                  : date.toLocaleDateString('es-ES')
                }
                style={{
                  width: '100%', aspectRatio: '1', minWidth: 16, maxWidth: 26,
                  borderRadius: 4, backgroundColor: bg, border,
                  cursor: worked ? 'pointer' : 'default',
                  transition: 'transform 0.15s'
                }}
                onMouseEnter={e => { if (worked) e.currentTarget.style.transform = 'scale(1.25)'; }}
                onMouseLeave={e => { if (worked) e.currentTarget.style.transform = 'scale(1)'; }}
              />
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 8, fontSize: '0.7rem', color: '#64748b', flexWrap: 'wrap', justifyContent: 'center' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <div style={{ width: 12, height: 12, backgroundColor: '#0ea5e9', borderRadius: 2 }}></div> Fichaje completo
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <div style={{ width: 12, height: 12, backgroundColor: '#f59e0b', borderRadius: 2 }}></div> Fichaje incompleto
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <div style={{ width: 12, height: 12, backgroundColor: '#22c55e', border: '2px solid #16a34a', borderRadius: 2 }}></div> Hoy
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <div style={{ width: 12, height: 12, backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: 2 }}></div> Sin fichaje
          </span>
        </div>
      </div>
    );
  }

  renderShiftCards() {
    const { shifts, promoter } = this.props;
    if (!shifts || !promoter) return null;

    const workingDays = {};
    shifts.forEach(shift => {
      const shiftDate = new Date(shift.date);
      const day = shiftDate.toISOString().substring(0, 10);
      if (!workingDays[day]) workingDays[day] = { shifts: [] };
      workingDays[day].shifts.push(shiftDate);
    });

    const sortedDays = Object.keys(workingDays).sort((a, b) => b.localeCompare(a)).slice(0, 14);

    if (sortedDays.length === 0) return (
      <div style={{ textAlign: 'center', color: '#64748b', padding: '20px 0' }}>
        <i className="fas fa-calendar-times" style={{ fontSize: 32, marginBottom: 8 }}></i>
        <p style={{ fontSize: '0.85rem' }}>Sin registros recientes</p>
      </div>
    );

    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 220px), 1fr))', gap: 10 }}>
        {sortedDays.map(day => {
          const sorted = workingDays[day].shifts.sort((a, b) => a - b);
          const startTime = sorted[0].toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
          const endTime = sorted[sorted.length - 1].toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
          const hours = sorted.length > 1 ? ((sorted[sorted.length - 1] - sorted[0]) / (1000 * 60 * 60)).toFixed(1) : null;
          const isComplete = sorted.length > 1;
          const displayDate = sorted[0].toLocaleDateString('es-ES', { weekday: 'short', day: '2-digit', month: 'short', timeZone: 'UTC' });
          return (
            <div key={day} style={{
              padding: '12px 14px',
              backgroundColor: 'white',
              borderRadius: 10,
              border: '1px solid #e2e8f0',
              fontSize: '0.8rem',
              borderLeft: `4px solid ${isComplete ? '#0ea5e9' : '#f59e0b'}`
            }}>
              <div style={{ fontWeight: 700, color: '#0a4080', marginBottom: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ textTransform: 'capitalize' }}>{displayDate}</span>
                <span style={{ fontSize: '0.65rem', color: '#94a3b8', fontWeight: 400 }}>
                  {sorted.length} {sorted.length === 1 ? 'login' : 'logins'}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', color: '#64748b', flexWrap: 'wrap' }}>
                <span><i className="fas fa-sign-in-alt" style={{ fontSize: '0.8em' }}></i> {startTime}</span>
                {isComplete && <><span>&#x2192;</span><span><i className="fas fa-sign-out-alt" style={{ fontSize: '0.8em' }}></i> {endTime}</span></>}
                {!isComplete && <span style={{ color: '#f59e0b', fontSize: '0.7rem' }}>sin salida</span>}
              </div>
              {hours && (
                <div style={{ marginTop: 4, fontSize: '0.7rem', color: '#0ea5e9', fontWeight: 600 }}>
                  <i className="fas fa-clock"></i> {hours}h trabajadas
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { promoter, objective, arqueos, shifts } = this.props

    if (!promoter || !shifts) {
      return (
        <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    const today = new Date().toISOString().split('T')[0];
    const dateLabel = new Date().toLocaleDateString('es-ES', { timeZone: 'UTC', weekday: 'long', day: '2-digit', month: 'long' });
    const todayStart = this.renderStartHour(promoter.fullname, today);
    const todayEnd = this.renderFinishHour(promoter.fullname, today);
    const isWorkingToday = todayStart !== 'None';

    const statCards = [
      { label: 'Entrada de hoy', value: todayStart === 'None' ? '--' : todayStart, icon: 'fa-sign-in-alt', color: '#0891b2' },
      { label: 'Salida de hoy', value: todayEnd === 'None' ? (isWorkingToday ? 'En curso' : '--') : todayEnd, icon: 'fa-sign-out-alt', color: '#7c3aed' },
      { label: 'Total diario', value: this.renderTotalHour(promoter.fullname, promoter.rest, today), icon: 'fa-clock', color: '#0a4080' },
      { label: 'Total semanal', value: this.renderTotalWeekHours(promoter.fullname, promoter.rest), icon: 'fa-calendar-week', color: '#059669' },
      { label: 'Total mensual', value: this.renderTotalMonthHour(promoter.fullname, promoter.rest), icon: 'fa-calendar-alt', color: '#d97706' },
    ];

    return (
      <div className="machines-admin-view">

        {/* Header */}
        <div className="mach-admin-header od-header-detail">
          <div className="od-header-left">
            <div style={{ width: 52, height: 52, borderRadius: '50%', overflow: 'hidden', flexShrink: 0, border: '2px solid rgba(255,255,255,0.2)' }}>
              <img
                src={`https://vacway-images.s3.eu-central-1.amazonaws.com/${promoter.fullname}.png`}
                alt={promoter.fullname}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={e => { e.target.onerror = null; e.target.src = 'https://vacway-images.s3.eu-central-1.amazonaws.com/default.png'; }}
              />
            </div>
            <div className="od-header-info">
              <div className="od-header-title">
                <span className="od-header-product">Promotor</span>
                <span className="od-header-serial">{promoter.fullname}</span>
              </div>
              <div className="od-header-meta">
                <span className="od-header-status-badge" style={{ background: isWorkingToday ? '#22c55e' : '#64748b' }}>
                  {isWorkingToday ? 'Trabajando hoy' : 'Sin fichar hoy'}
                </span>
                <span className="od-header-meta-item">
                  <i className="fas fa-id-card"></i>
                  Codigo:&nbsp;<strong>{promoter.password}</strong>
                </span>
                <span className="od-header-meta-item">
                  <i className="fas fa-briefcase"></i>
                  Jornada:&nbsp;<strong>{promoter.workingday}h</strong>
                </span>
                <span className="od-header-meta-item">
                  <i className="fas fa-coffee"></i>
                  Descanso:&nbsp;<strong>{this.getUserRest(promoter.rest)}</strong>
                </span>
                <span className="od-header-meta-item">
                  <i className="fas fa-calendar-day"></i>
                  {dateLabel}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Stat chips */}
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 16 }}>
          {statCards.map(c => (
            <div key={c.label} className="od-info-chip" style={{ '--chip-color': c.color, flex: '1 1 160px' }}>
              <div className="od-chip-icon"><i className={`fas ${c.icon}`}></i></div>
              <div>
                <span className="od-chip-label">{c.label}</span>
                <span className="od-chip-val">{c.value}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Shift activity */}
        <div style={{
          marginTop: 20,
          padding: 'clamp(14px,3vw,20px)',
          backgroundColor: '#f8fafc',
          borderRadius: 12,
          border: '1px solid #e2e8f0'
        }}>
          <h4 style={{ margin: '0 0 16px', color: '#1e293b', fontWeight: 700, fontSize: 'clamp(0.95rem,2vw,1.05rem)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="fas fa-chart-bar" style={{ color: '#0a4080' }}></i>
            Actividad de fichajes
            <span style={{ fontSize: '0.75rem', fontWeight: 400, color: '#64748b' }}>
              ({shifts.length} registros totales)
            </span>
          </h4>
          {this.renderShiftHeatmap()}
          <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: 10, fontWeight: 600 }}>
            <i className="fas fa-list"></i> Jornadas recientes
          </div>
          {this.renderShiftCards()}
        </div>

        {/* Monthly objectives */}
        {arqueos && objective && (
          <div style={{
            marginTop: 20,
            padding: 'clamp(14px,3vw,20px)',
            backgroundColor: '#f8fafc',
            borderRadius: 12,
            border: '1px solid #e2e8f0'
          }}>
            <h4 style={{ margin: '0 0 16px', color: '#1e293b', fontWeight: 700, fontSize: 'clamp(0.95rem,2vw,1.05rem)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <i className="fas fa-bullseye" style={{ color: '#0a4080' }}></i>
              Objetivos del mes
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div className="od-info-chip" style={{ '--chip-color': '#0a4080' }}>
                <div className="od-chip-icon"><i className="fas fa-euro-sign"></i></div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <span className="od-chip-label">Ventas del mes</span>
                  {(() => {
                    const real = this.calculateTotalMonthReal();
                    const obj = this.calculateTotalMonthObjective();
                    const pct = obj > 0 ? Math.min((real / obj) * 100, 100) : 0;
                    const barColor = pct < 50 ? '#ef4444' : pct < 100 ? '#f59e0b' : '#22c55e';
                    return (
                      <div style={{ marginTop: 6 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.72rem', color: '#64748b', marginBottom: 4 }}>
                          <span style={{ fontWeight: 700, color: barColor }}>{pct.toFixed(1)}%</span>
                        </div>
                        <div style={{ position: 'relative', height: 10, background: '#e2e8f0', borderRadius: 99, overflow: 'hidden' }}>
                          <div style={{ height: '100%', width: `${pct}%`, background: barColor, borderRadius: 99, transition: 'width 0.8s ease' }} />
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <div className="od-info-chip" style={{ '--chip-color': '#059669', flex: 1 }}>
                  <div className="od-chip-icon"><i className="fas fa-layer-group"></i></div>
                  <div>
                    <span className="od-chip-label">KPI LAY</span>
                    <span className="od-chip-val">{this.calculateTotalKPILay().toFixed(2)}%</span>
                  </div>
                </div>
                <div className="od-info-chip" style={{ '--chip-color': '#7c3aed', flex: 1 }}>
                  <div className="od-chip-icon"><i className="fas fa-rocket"></i></div>
                  <div>
                    <span className="od-chip-label">KPI GO</span>
                    <span className="od-chip-val">{this.calculateTotalKPIGo().toFixed(2)}%</span>
                  </div>
                </div>
                <div className="od-info-chip" style={{ '--chip-color': '#d97706', flex: 1 }}>
                  <div className="od-chip-icon"><i className="fas fa-random"></i></div>
                  <div>
                    <span className="od-chip-label">Venta cruzada</span>
                    <span className="od-chip-val">{this.calculateTotalCrossSale().toFixed(2)}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Full calendar */}
        <div style={{
          marginTop: 20,
          padding: 'clamp(14px,3vw,20px)',
          backgroundColor: '#f8fafc',
          borderRadius: 12,
          border: '1px solid #e2e8f0',
          marginBottom: 20
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
            <h4 style={{ margin: 0, color: '#1e293b', fontWeight: 700, fontSize: 'clamp(0.95rem,2vw,1.05rem)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <i className="fas fa-calendar" style={{ color: '#0a4080' }}></i>
              Calendario completo
            </h4>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
              {[['#dcfce7','#166534','#86efac','Correcto'],['#fef9c3','#854d0e','#fde047','Incompleto'],['#fee2e2','#991b1b','#fca5a5','Sin fichar'],['#f8fafc','#94a3b8','#e2e8f0','Finde']].map(([bg, color, border, label]) => (
                <span key={label} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.72rem', color: '#64748b' }}>
                  <span style={{ width: 12, height: 12, borderRadius: 3, background: bg, border: `1px solid ${border}`, display: 'inline-block' }} />
                  {label}
                </span>
              ))}
            </div>
          </div>
          {this.renderRegisterDaysShifts()}
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  shifts: state.shifts.shifts,
  promoter: state.promoters.promoter,
  objective: state.objectives.objective,
  arqueos: state.arqueos.arqueos,
  fullname: state.auth.fullname,
});

const mapDispatchToProps = dispatch => ({
  fetchShifts: bindActionCreators(fetchShifts, dispatch),
  fetchPromoter: bindActionCreators(fetchPromoter, dispatch),
  fetchObjective: bindActionCreators(fetchObjective, dispatch),
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoterShiftView);
